import { Grid } from '@fs/zion-ui'
import React from 'react'
import LifeSketchCardSkeleton from '../cards/life-sketch-card/LifeSketchCardSkeleton'
import OtherInformationCardSkeleton from '../cards/other-information-card/OtherInformationCardSkeleton'
import OtherRelationshipsCardSkeleton from '../cards/other-relationships-card/OtherRelationshipsCardSkeleton'

export default function NonVitalsTabSkeleton(): JSX.Element {
  return (
    <Grid gutters="nano">
      <OtherInformationCardSkeleton />
      <OtherRelationshipsCardSkeleton />
      <LifeSketchCardSkeleton />
    </Grid>
  )
}
